import { useState, useEffect } from 'react';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

const DEFAULTS = {
  ocr_activo:                  true,
  posse_threshold_usd:         100,
  score_min_fornecedor_conf:   75,
  fornecedor_conf_pede_posse:  false,
  upload_massa_activo:         true,
  upload_massa_max_produtos:   50,
  upload_massa_score_min:      60,
};

export function usePlatformSettings() {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loading,  setLoading]  = useState(true);

  const carregar = async () => {
    const tk = token();
    if (!tk) { setLoading(false); return; }
    try {
      const res  = await fetch(`${BASE}/platform-settings`, {
        headers: { Authorization: `Bearer ${tk}` },
      });
      const data = await res.json();
      if (data.sucesso && data.obj) {
        setSettings({ ...DEFAULTS, ...data.obj });
      }
    } catch {}
    setLoading(false);
  };

  useEffect(() => {
    carregar();
    // Polling a cada 60 segundos para captar mudanças do admin em tempo real
    const id = setInterval(carregar, 60 * 1000);
    return () => clearInterval(id);
  }, []); // eslint-disable-line

  return { settings, loading };
}
